export const faqItems = [
  {
    id: "faq-1",
    question: "Kampanya fiyatları tek seans için mi?",
    answer:
      "Lazer epilasyon kampanyalarında belirtilen fiyatlar tek seans içindir. İhtiyacınıza uygun seans planlaması için WhatsApp üzerinden bize ulaşabilirsiniz.",
  },
  {
    id: "faq-2",
    question: "Cilt bakımı kampanyasına hangi uygulamalar dahil?",
    answer:
      "Medikal cilt bakımı, enzim peeling, carboxy cilt bakımı, cam cilt bakımı, anti-aging cilt bakımı, leke & akne odaklı cilt bakımı, kolajen ip dolgu tozu ve iğnesiz mezoterapi dahildir. Kampanya kapsamındaki her uygulama 1.000 TL’dir.",
  },
  {
    id: "faq-3",
    question: "Randevu nasıl oluşturabilirim?",
    answer:
      "Sayfadaki WhatsApp butonlarından birine dokunarak hazır mesajla bize yazabilir ya da 0542 185 02 01 numarasını arayabilirsiniz. Size uygun gün ve saat için birlikte planlıyoruz.",
  },
  {
    id: "faq-4",
    question: "Uygulama öncesinde bilgi alabilir miyim?",
    answer:
      "Elbette. Uygulama kapsamı, süresi ve size uygun seçenekler hakkında uygulama öncesinde WhatsApp üzerinden bilgi alabilirsiniz.",
  },
  {
    id: "faq-5",
    question: "Salon nerede?",
    answer:
      "Demirtaş Sakarya Mahallesi, Demirtaş Sanayi Çevre Yolu Caddesi No:2/1, Osmangazi / Bursa adresindeyiz. İletişim bölümündeki ‘Yol Tarifi Alın’ butonuyla konuma ulaşabilirsiniz.",
  },
  {
    id: "faq-6",
    question: "Simülasyon ve kamuflaj fiyatları nasıl belirleniyor?",
    answer:
      "Simülasyon ve kamuflaj uygulamalarında fiyat, uygulama yapılacak bölgeye göre değerlendirilir. Bölge bilgisini paylaşarak WhatsApp üzerinden ön değerlendirme ve fiyat bilgisi alabilirsiniz.",
  },
];